// extracted by mini-css-extract-plugin
module.exports = {"st0":"MobileLogo_st0__ES-_I","st1":"MobileLogo_st1__2OJIV"};